import { render, staticRenderFns } from "./syncProjection.vue?vue&type=template&id=a40f2754&scoped=true&"
import script from "./syncProjection.vue?vue&type=script&lang=js&"
export * from "./syncProjection.vue?vue&type=script&lang=js&"
import style0 from "./syncProjection.vue?vue&type=style&index=0&id=a40f2754&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40f2754",
  null
  
)

export default component.exports